export const getHeaderWithProjectId = () => {
    return {
        headers: {
            projectID: "9sa80czkq1na"
        }
    }
}